import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExperienceStyle } from '@ess-front/shared';

@Component({
  selector: 'ess-experience-editor-tips',
  templateUrl: './experience-editor-tips.component.html',
  styleUrls: ['./experience-editor-tips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExperienceEditorTipsComponent {
  @Input() experienceStyle: string | null = null;
  @Input() quote: string | null = null;

  ExperienceStyle = ExperienceStyle;
}
